import { getCall, postCall, putCall } from "./api";

// Available permission catalogue (grouped by topic).
export const getPermissionCatalogue = async () => {
  return await getCall({ path: `/new-permission` });
};

// Org roles
export const getRoles = async () => {
  return await getCall({ path: `/new-role` });
};

// { name, description, permissions: [string] }
export const createRole = async (input = {}) => {
  return await postCall({ path: `/new-role`, bodyParams: input });
};

export const updateRole = async (id, input = {}) => {
  return await putCall({ path: `/new-role/${id}`, bodyParams: input });
};

// Assign roles + special permissions to an employee.
// { newRoles: [roleId], newSpecialPermissions: [permName] }
export const updateEmployeeRoles = async (employeeId, input = {}) => {
  return await putCall({ path: `/employee/${employeeId}/roles-permissions`, bodyParams: input });
};
